import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
    connect() {
        const lang = document.documentElement.lang.split('-')[0];

        this.element.classList.add('loading');

        const postID = this.element.dataset.pid;
        const blockID = this.element.dataset.bid;

        const queryParams = window.location.search.slice(1);
        let url = `/wp-json/api/async-render-block?pid=${postID}&bid=${blockID}&rest_language=${lang}`;

        if (queryParams) {
            url += `&${queryParams}`;
        }

        Axios.get(url)
            .then(response => {
                this.element.classList.remove('loading');

                if (response.data.success) {
                    this.element.innerHTML = response.data.data.content;
                }
            })
            .catch(() => {
                this.element.classList.remove('loading');
            });
    }
}
